import { useGetAllPermissionsMutation } from "../store/services/permissionsQuery";

export const usePermission = () => {
  const [
    getAllPermissions,
    {
      data: allPermissionData,
      isLoading: allPermissionIsLoading,
      isError: allPermissionIsError,
      error: allPermissionError,
      isSuccess: allPermissionSuccess,
    },
  ] = useGetAllPermissionsMutation();

  return {
    getAllPermissions,
    allPermissionData,
    allPermissionIsLoading,
    allPermissionIsError,
    allPermissionError,
    allPermissionSuccess,
  };
};
